<!--
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-31 20:25:13
 * @Description:
-->
<template>
  <div>
    <div v-if="cardTypeObj" class="tip-wrap">
      <span class="expiring-soon-tip" v-if="expiringSoonTip && cardType !== 18">近30天{{ expiringSoonTip }}个权益即将过期</span>
      <a-tooltip placement="top">
        <template v-if="cardTypeObj.tip" #title>
          <p>{{ cardTypeObj.tip }}</p>
        </template>
        <p class="card-wrap">
          {{ cardTypeObj.name }}剩余<i class="remain-num">{{ residueNumber }}</i>个
        </p>
      </a-tooltip>
      <a-tooltip v-if="cardType !== 18" placement="bottom">
        <template slot="title">
          <p>已过期名额：{{ expireNumber }}</p>
        </template>
        <a-icon type="exclamation-circle" style="color: #767D91;padding-left: 4px;cursor: pointer;" />
      </a-tooltip>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    // 卡片类型(10：体验权益 11：一年A类权益  12:一年B类权益  13:一年有效全科权益 14：三年有效全科权益  15:永久有效全科权益 1000:全科)
    cardType: Number,
    expiringSoonTip: Number, // 即将过期名额
    expireNumber: Number, // 已过期名额
    // 剩余名额
    residueNumber: Number
  },
  watch: {
    cardType() {
      this.getCardTypeObj()
    }
  },
  methods: {
    getCardTypeObj() {
      const { cardType } = this
      if (cardType === 11) {
        return {
          name: '一类',
          tip: '适用于小初年级：上册入门-暑；上册-秋；下册-春；新概念课程'
        }
      }
      if (cardType === 12) {
        return {
          name: '二类',
          tip: '适用于小初年级：下册入门-寒；自然拼读课程'
        }
      }
      if (cardType === 16) {
        return {
          name: '高中一类',
          tip: '适用于高中年级：上册入门-暑；上册-秋；下册-春'
        }
      }
      if (cardType === 17) {
        return {
          name: '高中二类',
          tip: '适用于高中年级：下册入门-寒'
        }
      }

      if (cardType === 18) {
        return {
          name: '次卡',
          tip: ''
        }
      }
      // TODO 其他的，待添加
      return null
    }
  },
  computed: {
    cardTypeObj() {
      return this.getCardTypeObj()
    }
  }
}
</script>
<style lang="less" scoped>
.tip-wrap {
  display: flex;
  position: relative;
  .expiring-soon-tip {
    position: absolute;
    left: -24px;
    top: 15px;
    font-size: 12px;
    color: #FF8800;
    width: 160px;
  }
}
.card-wrap {
  line-height: 1;
  display: flex;
  align-items: center;
  line-height: 1;
  font-weight: 400;
  font-size: 12px;
  color: #303858;

  .tip-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #3262FD;
    border-radius: 50%;
    margin: 0 2px;
  }
  .remain-num {
    color: #FF8800;
  }
}
</style>